var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8278)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8278",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0238C23.3738 49.0241 21.7517 48.8605 20.1584 48.5355C17.0855 47.9061 14.1666 46.6779 11.5683 44.9208C7.70572 42.3136 4.68231 38.642 2.86445 34.3511C2.25005 32.8978 1.7811 31.3873 1.46446 29.8416C0.81393 26.6467 0.81393 23.3534 1.46446 20.1585C2.09405 17.0856 3.32231 14.1667 5.07927 11.5682C7.68672 7.70584 11.3583 4.68249 15.649 2.86436C17.1023 2.25011 18.6127 1.78125 20.1584 1.46465C23.3533 0.813866 26.6467 0.813866 29.8416 1.46465C32.9145 2.09393 35.8334 3.32218 38.4317 5.07936C42.2942 7.68659 45.3175 11.3582 47.1353 15.649C47.7498 17.1023 48.2189 18.6128 48.5355 20.1585C49.1861 23.3534 49.1861 26.6467 48.5355 29.8416C47.9058 32.9145 46.6775 35.8334 44.9205 38.4319C42.3133 42.2944 38.6418 45.3177 34.351 47.1357C32.8977 47.75 31.3873 48.2189 29.8416 48.5355C28.2482 48.8605 26.6262 49.0241 25 49.0238ZM15.5468 10.5704C15.0587 10.5711 14.5781 10.6891 14.1453 10.9147H14.1443C12.8164 11.6112 11.8029 12.7865 11.3094 14.2025C10.8159 15.6185 10.8792 17.1691 11.4866 18.5401C13.2949 22.6091 15.7331 26.3678 18.7115 29.6778L20.944 31.91C24.2538 34.8886 28.0125 37.3267 32.0816 39.1346C33.4519 39.7464 35.0041 39.8121 36.4212 39.3183C37.8383 38.8245 39.0136 37.8084 39.707 36.4775L39.7076 36.4765C40.0521 35.815 40.1415 35.0501 39.9588 34.327C39.776 33.6039 39.3339 32.9732 38.7165 32.5548L34.0933 29.4171C33.72 29.1638 33.2789 29.029 32.8278 29.0302C32.3766 29.0315 31.9364 29.1687 31.5645 29.4241L30.4682 30.1761C29.8726 30.5844 29.163 30.7936 28.4412 30.7737C27.7194 30.7538 27.0225 30.5058 26.4503 30.0653C24.2077 28.3995 22.2217 26.4135 20.5559 24.1709C20.1152 23.5988 19.8672 22.9018 19.8473 22.18C19.8274 21.4581 20.0367 20.7486 20.4452 20.1531L21.1973 19.0568C21.4543 18.6855 21.5925 18.245 21.5937 17.7935C21.5949 17.3419 21.459 16.9007 21.204 16.528L18.0668 11.9049C17.7878 11.4935 17.4122 11.1568 16.9729 10.9241C16.5336 10.6915 16.0439 10.57 15.5468 10.5704Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactWithWhiteCircle);
export default __webpack_public_path__ + "static/media/contact_with_white_circle.698c2a6df7f057fcece9356c1fa5bab4.svg";
export { ForwardRef as ReactComponent };